export const DEBOUNCE_INTERVAL = 500; // milliseconds
export const TRANSFER_DOC_VERSION = "2023"; // if changing this value be sure to change it in /skels/utility.xslskel and in mi-dmz/libs/MOVEit.DMZ.Core/Constants.cs as well
